module.exports = __webpack_public_path__ + "img/26.71c89b53.jpg";